import { STATIC_STRINGS } from "../../../../../utils/Constants";
import { updateExperience, updateSkills } from "../../../../../store/steps/stepOneSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import GenericAutocomplete from "../../../../../common/GenericAutocomplete";
import Slider from "@mui/material/Slider";

const ExperienceSkills = ({ setOpen }) => {
  const handleOpen = () => setOpen(true);

  const dispatch = useDispatch();
  const { skills, experience } = useSelector((state: RootState) => state.stepOne);

  const handleSliderChange = (e, newValue) => {
    dispatch(updateExperience(newValue as number[]));
  };

  const formatExperience = (exp: number[]) => {
    return `${exp[0]} - ${exp[1] === 11 ? "10+" : exp[1]} Years`;
  };

  return (
    <div className="flex flex-col w-2/5 mx-auto h-4/5 my-auto justify-around">
      <div className="flex flex-col p-2">
        <div className="font-medium p-2 flex justify-between">
          <div>{STATIC_STRINGS.EXPERIENCE_RANGE}</div>
          <div>{formatExperience(experience)}</div>
        </div>
        <Slider
          value={experience}
          min={0}
          max={11}
          onChange={(e, newValue) => handleSliderChange(e, newValue)}
          sx={{ color: "var(--color-neutral-dark)" }}
          valueLabelDisplay="auto"
          valueLabelFormat={(value) => (value === 11 ? "10+" : value)}
        />
      </div>
      <div className="flex flex-col p-2">
        <div className="flex justify-between items-center pb-4">
          <div className="font-medium">{STATIC_STRINGS.SKILLS_TITLE}</div>
          <button onClick={handleOpen} className="btn btn-primary p-1 px-2">
            {STATIC_STRINGS.TAKE_AI_HELP}
          </button>
        </div>
        <GenericAutocomplete
          options={[...skills]}
          freeSolo={true}
          value={skills}
          onChangeHandler={(event, newValue) =>
            dispatch(updateSkills([...newValue]))
          }
          placeholder={STATIC_STRINGS.SKILLS_PLACEHOLDER}
        />
      </div>
    </div>
  );
};

export default ExperienceSkills;
